// Components/InfoChip.tsx
import React from 'react'
import { Chip } from '@mui/material'
import { SxProps, Theme } from '@mui/material/styles'

interface InfoChipProps {
  label: string
  sx?: SxProps<Theme>
  size?: 'small' | 'medium'
}

export const InfoChip: React.FC<InfoChipProps> = ({
  label,
  sx,
  size = 'medium'
}) => (
  <Chip
    label={label}
    size={size}
    color='secondary'
    variant='outlined'
    sx={sx}
  />
)
